import React, { useContext } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { AccountContext } from "../Account/Account";
import { types } from "types/types";

function Header() {
  const { dispatch } = useContext(AccountContext);

  const finishSession = () => {
    dispatch({ type: types.logout });
  };

  return (
    <Navbar bg="light" expand="lg" className="admin-navbar">
      <Container fluid>
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav navbar>
            <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  finishSession();
                }}
              >
                <span className="no-icon">Cerrar sesión</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
